import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ExecutionInfoResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useExecutionInfo = (id: string) => {
  return useQuery<any, AxiosError<any>, ExecutionInfoResponse>(
    ["execution", id],
    () =>
      axiosClient
        .get<ExecutionInfoResponse>(`/execution/getOne/${id}`)
        .then(({ data }) => data),
    { staleTime: Infinity }
  );
};
